import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Button, DialogActions, DialogContent, Paper, Stack, TextField, Typography } from '@mui/material';
import { api, ui, state } from '../../../../../../interfaces/interfaces';
import { fetchAgain } from '../EnquiryTabs';
import { useAppSelector } from "@store/hooks";
import { getISODate } from '../../../../../../utilities/general';

const handleClose = () => {
    ui.FollowUpDialogModal = false
    ui.FollowUpValue = ''
};
const handleFollowUp = async (leadId: number) => {
    if (ui.FollowDateTime) {
        const dateUI = new Date(ui.FollowDateTime)
        const dateTimeFollowUp = getISODate(dateUI)
        // date.setUTCHours(dateUI.getHours(), dateUI.getMinutes(), dateUI.getSeconds())
        // date.setUTCFullYear(dateUI.getFullYear(), dateUI.getMonth(), dateUI.getDate())
        await api.fetchGetCallMeSetFollowUp({
            leadId,
            userId: state.UserId,
            dateTimeFollowUp,
            followUpNotes: ui.FollowUpValue,
        });
        await fetchAgain()
    }
    handleClose()
};

const handleDateTimeChange = (e: any) => {
    ui.FollowDateTime = e.target.value
}

const handleFollowUpValue = (e: any) => {
    ui.FollowUpValue = e.target.value
}

type Props = {
    leadId: number
}

const FollowUpDialog: React.FC<Props> = ({ leadId }) => {
    const followUpDialogModal = useAppSelector(({ ui }) => ui.FollowUpDialogModal);
    const followUpValue = useAppSelector(({ ui }) => ui.FollowUpValue);
    const followUpDateTime = useAppSelector(({ ui }) => ui.FollowUpDateTime);

    return (
        (<Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={followUpDialogModal} maxWidth="sm" fullWidth>
            <DialogTitle id="simple-dialog-title">Please provide feedback</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <Paper elevation={4}>
                        <Typography variant="body1" sx={{ fontWeight: "bold", p: 1 }}>Please provide follow up message and date/time.</Typography>
                    </Paper>
                    <Paper elevation={4}>
                        <Typography variant="body1" sx={{ fontWeight: "bold", p: 1 }}> <TextField
                            id="datetime-local"
                            label="Next appointment"
                            type="datetime-local"
                            // defaultValue="2017-05-24T10:30"
                            sx={{ width: 250 }}
                            onChange={handleDateTimeChange}
                            value={followUpDateTime}
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                }
                            }}
                        /></Typography>
                    </Paper>
                    <Paper elevation={4}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Follow Up Message"
                            type="text"
                            fullWidth
                            variant="outlined"
                            multiline
                            onChange={handleFollowUpValue}
                            value={followUpValue}
                            rows={4}
                            sx={{ p: 1 }}
                        />
                    </Paper>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button color='success' variant='outlined' onClick={handleClose}>Cancel</Button>
                <Button color='error' variant='contained' onClick={() => handleFollowUp(leadId)}>Follow Up</Button>
            </DialogActions>
        </Dialog >)
    );
}

export default React.memo(FollowUpDialog);